<button class="me-2" mat-raised-button [matMenuTriggerFor]="tradeActionsMenu">
  <mat-icon>settings</mat-icon> Actions
</button>

<mat-menu
  #tradeActionsMenu="matMenu"
  direction="down"
  yPosition="below"
  class="unified-menu"
>
  @if (recordStatus !== 'INP') {
    <button mat-menu-item (click)="toggleStatus.emit('INP')">
      <mat-icon>construction</mat-icon> Mark In Process
    </button>
  }
  @if (recordStatus !== 'REJ' && recordType === 'trade') {
    <button mat-menu-item (click)="toggleStatus.emit('REJ')">
      <mat-icon>dangerous_outlined</mat-icon> Reject
    </button>
  }
  @if (recordStatus !== 'APP' && recordType === 'trade') {
    <button mat-menu-item (click)="toggleStatus.emit('APP')">
      <mat-icon>check_circle_outline</mat-icon> Approve
    </button>
  } @else if (
    recordStatus !== 'REV' &&
    (recordType === 'account' || recordType === 'rep' || recordType === 'aml')
  ) {
    <button mat-menu-item (click)="toggleStatus.emit('REV')">
      <mat-icon>check_circle_outline</mat-icon> Mark as Reviewed
    </button>
  } @else {
    <button mat-menu-item (click)="toggleStatus.emit('REO')">
      <mat-icon>meeting_room</mat-icon> Reopen
    </button>
  }
</mat-menu>
